import React from 'react';

const UserManagement = () => {
  return (
    <div><h1>usermanagement</h1></div>
  )
}

export default UserManagement;